import React, { useContext } from 'react';
import { Box, SxProps, useTheme } from '@mui/material';
import { UiContext } from 'shared/lib/contexts/uiContext';
import { useBooleanScreens } from 'shared/hooks/useBooleanScreens';

export default function SectionWidgetInner({
  sx,
  slots,
}: {
  sx?: SxProps;
  slots: {
    header: React.ReactNode;
    amount: React.ReactNode;
  };
}) {
  const {
    spacings: { sp },
  } = useContext(UiContext);

  return (
    <>
      <Box
        sx={{
          position: 'relative',
          zIndex: 1,
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-between',
          textWrap: 'wrap',
          height: 1,
          width: 1,
          ...sx,
        }}
      >
        {slots.header}
        <Box
          sx={{
            display: 'flex',
            width: 1,
            justifyContent: 'space-between',
          }}
        >
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'end',
            }}
          >
            {slots.amount}
          </Box>
        </Box>
      </Box>
    </>
  );
}
